module.exports = __webpack_public_path__ + "bb2a7e91c901f6e1e7853a77f08651f7.pdf";